import { createAction } from '@reduxjs/toolkit';

export const PERSIST_SLICE_KEYS = [
	'app',
	'events',
	'plans',
	'signup',
	'map',
	'checkout',
] as const;

export type PersistedSliceKey = (typeof PERSIST_SLICE_KEYS)[number];

export const REVOLUT_PAY_TAB_SLICE_KEYS = PERSIST_SLICE_KEYS.filter(
	(key): key is Exclude<PersistedSliceKey, 'checkout'> => key !== 'checkout'
);

export type PersistedSlicesState = Partial<
	Record<PersistedSliceKey, Record<string, unknown>>
>;

export const restorePersistedTabState = createAction<PersistedSlicesState>(
	'revolutPay/restorePersistedTabState'
);

export const pickRevolutPayTabSlices = (
	state: Record<string, unknown>
): PersistedSlicesState => {
	const snapshot: PersistedSlicesState = {};

	for (const key of REVOLUT_PAY_TAB_SLICE_KEYS) {
		const slice = state[key];
		if (slice && typeof slice === 'object') {
			snapshot[key] = { ...(slice as Record<string, unknown>) };
		}
	}

	return snapshot;
};

export const mergePersistedTabState = (
	state: Record<string, unknown>,
	payload: PersistedSlicesState
): Record<string, unknown> => {
	const nextState = { ...state };

	for (const key of REVOLUT_PAY_TAB_SLICE_KEYS) {
		const slice = payload[key];
		if (slice != null) {
			nextState[key] = slice;
		}
	}

	return nextState;
};
